import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-logoc',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logoc.component.html',
  styleUrl: './logoc.component.scss'
})
export class LogocComponent {

}
